import React from "react";

const MinusIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cls}
    >
      <path
        d="M12 2C6.48583 2 2 6.48583 2 12C2 17.5142 6.48583 22 12 22C17.5142 22 22 17.5142 22 12C22 6.48583 17.5142 2 12 2ZM12 20.3333C7.405 20.3333 3.66667 16.595 3.66667 12C3.66667 7.405 7.405 3.66667 12 3.66667C16.595 3.66667 20.3333 7.405 20.3333 12C20.3333 16.595 16.595 20.3333 12 20.3333ZM16.1667 9.5H7.83333C6.91417 9.5 6.16667 10.2475 6.16667 11.1667V12.8333C6.16667 13.7525 6.91417 14.5 7.83333 14.5H16.1667C17.0858 14.5 17.8333 13.7525 17.8333 12.8333V11.1667C17.8333 10.2475 17.0858 9.5 16.1667 9.5ZM7.83333 12.8333V11.1667H16.1667V12.8333H7.83333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MinusIcon;
